// Full-document render of the lookup-orders-by-email confirmation page:
// PageSkeleton wrapping the legacy stearns account-page layout -- the brand
// heading, the static confirmation copy, and the decorative account image. The
// copy is the stearns legacy template's own, reproduced verbatim -- including
// the legacy "Tempurpedic.com order" line, a pre-existing copy bug on stearns
// kept for behavior preservation; stearns serves en-us only, so the plain
// literals match the legacy {% blocktrans %} output.
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LookupOrdersByEmailConfirmationDocumentTemplate,
): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <header>
                    <h1>Your Stearns &amp; Foster® Orders</h1>
                </header>

                <section className="account-page-container">
                    <div>
                        <h2>Your Order Status</h2>
                        <div>
                            <p>
                                Your order status request has been submitted. If
                                an order associated with this email address is
                                located, we&rsquo;ll send you a link to view
                                your order history. You should receive an email
                                from us within a few minutes.
                            </p>
                            <p>
                                If you don&rsquo;t receive an order status email
                                from us within 10 minutes, please check your
                                spam folder. Also please verify that the email
                                address you entered is the exact same email
                                address you used to place your Tempurpedic.com
                                order.
                            </p>
                        </div>
                    </div>
                    <div>
                        {/* Decorative image: empty alt attr */}
                        <img
                            src={`${staticURL}img/accounts/accounts-page-img.jpg`}
                            alt=""
                        />
                    </div>
                </section>
            </div>
        </PageSkeleton>
    );
};
